import { FC, Fragment } from 'react';
import { Pax } from 'ts/flight/interfaces/FlightBookResponse';
import { BookOptionsCatalogue } from 'ts/flight/classes/BookOptionsCatalogue';
import OptionalService from './OptionalService';

interface OptionalServicesProps {
  catalogue: BookOptionsCatalogue;
  restrictOptionalService: boolean;
  pax: Pax;
  paxIndex: number;
  onChangeField: (newPax: Pax, index: number) => Promise<void>;
  flightSource: string;
}

const OptionalServices: FC<OptionalServicesProps> = ({
  catalogue,
  restrictOptionalService,
  pax,
  ...props
}) => {
  return (
    <Fragment>
      {!restrictOptionalService &&
        catalogue.visible &&
        [
          ...catalogue.outboundBaggage.paxTypes,
          ...catalogue.outboundMeal.paxTypes,
          ...catalogue.inboundBaggage.paxTypes,
          ...catalogue.inboundMeal.paxTypes,
        ].includes(pax.paxTypeCode) && (
          <div className="form-wrapper row">
            <OptionalService
              pax={pax}
              paxIndex={props.paxIndex}
              bagMeal={catalogue.outboundBaggage}
              flightSource={props.flightSource}
              onChangeField={props.onChangeField}
              key1="baggageOutbound"
            />
            <OptionalService
              pax={pax}
              paxIndex={props.paxIndex}
              flightSource={props.flightSource}
              onChangeField={props.onChangeField}
              bagMeal={catalogue.outboundMeal}
              key1="mealOutbound"
            />
            <OptionalService
              pax={pax}
              paxIndex={props.paxIndex}
              bagMeal={catalogue.inboundBaggage}
              flightSource={props.flightSource}
              onChangeField={props.onChangeField}
              key1="baggageInbound"
            />
            <OptionalService
              pax={pax}
              paxIndex={props.paxIndex}
              flightSource={props.flightSource}
              onChangeField={props.onChangeField}
              bagMeal={catalogue.inboundMeal}
              key1="mealInbound"
            />
          </div>
        )}
    </Fragment>
  );
};

export default OptionalServices;
